import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgFilterDollar = forwardRef((props, ref) => /* @__PURE__ */ jsxs(BaseIcon, { fill: "none", ref, ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M3.699 6.317C2.567 5.024 3.486 3 5.204 3h13.55c1.732 0 2.646 2.05 1.487 3.338L17.47 9.342s-.463-.206-.618-.24a4 4 0 0 0-.921-.106c-.903 0-2.138.66-2.572 1.73-1.325.85-1.692 1.814-1.793 2.008-.1.195-.261.532-.34 1.215-.078.684 0 1.606.524 2.469a3 3 0 0 0-.332.438c-.094.148-.59.874-.352 2.144-.199 0-.638-.158-.92-.44l-.707-.706A1.5 1.5 0 0 1 9 16.793v-4.417z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.06 11a1 1 0 0 1 1 1v.101a3.43 3.43 0 0 1 1.668.972 1 1 0 1 1-1.456 1.37c-.19-.202-.45-.35-.749-.414a1 1 0 0 1-.107-.029 1 1 0 0 0-.166-.04 1 1 0 0 1-.374 0 1 1 0 0 0-.23.066.97.97 0 0 0-.45.367l.003.007c.013.043.051.12.14.215.18.197.497.393.89.484.746.17 1.437.557 1.919 1.083.476.52.846 1.306.59 2.17a1 1 0 0 1-.051.135 2.95 2.95 0 0 1-1.627 1.508V20a1 1 0 0 1-1.997.075l-.046-.014a3.43 3.43 0 0 1-1.75-1.006 1 1 0 0 1 1.467-1.359c.19.206.453.357.754.42a1 1 0 0 1 .106.03q.113.037.231.05a1 1 0 0 1 .36-.02q.09-.02.178-.056a.97.97 0 0 0 .45-.368v-.003a.6.6 0 0 0-.14-.216c-.182-.198-.5-.395-.892-.485-.745-.171-1.435-.555-1.917-1.082-.478-.52-.844-1.304-.593-2.167a1 1 0 0 1 .052-.14 2.95 2.95 0 0 1 1.737-1.548V12a1 1 0 0 1 1-1",
      clipRule: "evenodd"
    }
  )
] }));

export { SvgFilterDollar as default };
//# sourceMappingURL=filter-dollar.mjs.map
